import {
    ColumnType,
    yascDisplayName,
    yascTableIgnore,
    yascBic,
    yascIban,
    yascMaxLength,
    yascMinLength,
    yascRequired,
    yascFormIgnore,
} from '@yasc/yasc-material-components';
import {
    yascFormPlaceholder,
    yascFormTooltip, yascTableColumn
} from '@yasc/yasc-material-components';

export class BankAccountRes {
    @yascTableIgnore(true)
    @yascFormIgnore()
    public guid!: string;

    @yascDisplayName('formular_bankAccount_accountOwner_label')
    @yascRequired()
    @yascMinLength(2)
    @yascMaxLength(100)
    public accountOwner!: string;

    @yascDisplayName('formular_bankAccount_bankName_label')
    @yascRequired()
    @yascMinLength(2)
    @yascMaxLength(100)
    public bankName!: string;

    @yascDisplayName('formular_bankAccount_iban_label')
    @yascRequired()
    @yascIban()
    @yascMinLength(15)
    @yascMaxLength(34)
    @yascFormPlaceholder('DE89 3704 0044 0532 0130 00')
    @yascFormTooltip('formular_bankAccount_iban_hint')
    public iban!: string;

    @yascDisplayName('formular_bankAccount_bic_label')
    @yascRequired()
    @yascBic()
    @yascMinLength(8)
    @yascMaxLength(11)
    @yascFormPlaceholder('COBADEFFXXX')
    @yascFormTooltip('formular_bankAccount_bic_hint')
    public bic!: string;

    @yascDisplayName('formular_bankAccount_default_label')
    @yascTableColumn(ColumnType.Switch)
    public default!: boolean;

    @yascDisplayName('formular_bankAccount_billingAccountOnly_label')
    @yascTableColumn(ColumnType.Switch)
    public billingAccountOnly!: boolean;

    @yascTableIgnore(true)
    @yascFormIgnore()
    public finApiBankId?: number;

    constructor(account?: BankAccountRes) {
        if (account === undefined) return;

        this.accountOwner = account.accountOwner;
        this.bankName = account.bankName;
        this.iban = account.iban;
        this.bic = account.bic;
        this.guid = account.guid;
        this.default = account.default;
        this.billingAccountOnly = account.billingAccountOnly;
        this.finApiBankId = account.finApiBankId;
    }

    toString(): string {
        return `IBAN: ${this.iban}\nBic: ${this.bic}`;
    }
}

export class TaxOfficeDetailsRes {
    id?: number;
    @yascDisplayName('general_name')
    @yascMaxLength(100)
    name: string = '';
}

export class CourtOfficeDetailsRes {
    id?: number;
    @yascDisplayName('general_name')
    @yascMaxLength(100)
    name: string = '';
    @yascDisplayName('general_nr')
    @yascMaxLength(50)
    nr: string = ''
}
